// extracted by mini-css-extract-plugin
export default {"container":"ConfigActivator_container__0IhvZ","label":"ConfigActivator_label__PVz-Q"};